<template>
    <card bg="bg-dark text-white" title="Muestras Confirmadas">
        <card v-if="detailNew.length > 0" title="Nuevo Producto">
            <div class="table-responsive">
                <div v-for="item in detailNew" :key="item.id">
                    <div class="card mb-4 cardShadow">
                        <div class="card-header">
							<div class="row">
								<div class="col-md-12">
									<h5 class="card-title d-inline"><b>VINO: {{ item.variety }}
                                        {{ item.valley }} {{ item.quality }}</b></h5>
								</div>
							</div>
						</div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12 text-right">
									<div v-if="item.sampleDetailStage > 0" :id="'status-color-' + item.id">
										<h4>
											<b><span :class="'badge ribbon-h-' +item.statusColor" :id="'status-text-' + item.id">
												<i class="fa fa-info-circle mr-4"></i>Estado: {{ item.status }}
											</span></b>
										</h4>
									</div>
								</div>
                                <div class="col-md-12 table-responsive">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th>Marca</th>
                                                <th v-if="item.comercialMixCode" style="width: 20%">
                                                    Mezcla Comercial
                                                </th>
                                                <th>Vino</th>
                                                <th>Botellas</th>
                                                <th>Etapa</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="font-size: 20px !important;">
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.brand }}</span>
                                                </td>
                                                <td v-if="item.comercialMixCode">
                                                    <span class="badge badge-info p-2">
                                                        {{ item.comercialMix }} - {{ item.comercialMixCode }}
                                                    </span>
                                                </td>
                                                <td>
													<span class="badge badge-info p-2">{{ item.variety }}</span> 
																										<span class="badge badge-info p-2 ml-1">{{ item.valley }}</span>
													<span class="badge badge-info p-2 ml-1">{{ item.quality }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-success p-2">{{ item.quantity }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">
                                                        <i class="fa fa-info-circle"></i>
                                                        {{ item.stage }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered">
                                        <tr class="thead-dark text-center">
                                            <th>Muestra Enológica</th>
                                            <th>Con Degustación</th>
                                            <th>Con Cosecha Histórica/Próxima</th>
                                            <th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                                        </tr>
                                        <tr class="text-center" style="font-size: 20px !important;">
                                            <td>
                                                <i v-if="item.wineSample" class="fa fa-check text-success"></i>
                                                <i v-if="!item.wineSample" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.withTasting" class="fa fa-check text-success"></i>
                                                <i v-if="!item.withTasting" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.isHistoricalOrUpcoming" class="fa fa-check text-success"></i>
                                                <i v-if="!item.isHistoricalOrUpcoming" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <span class="badge badge-success p-2">{{ item.finalHarvest }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered"
                                            v-if="item.estimatedDeliveryDateOenology
                                            || item.deliveryDateOenology
                                            || item.wineryValidatedAt
                                            || item.qualityValidationDate
                                            || item.wineryDispatch
                                            || item.internalDispatchGuide"
                                        >
                                        <tr class="thead-dark">
                                            <th v-if="item.estimatedDeliveryDateOenology">Entrega Estimada Enología</th>
                                            <th v-if="item.deliveryDateOenology">Entrega Enología</th>
                                            <th v-if="item.wineryValidatedAt">Validación de Componentes</th>
                                            <th v-if="item.qualityValidationDate">Validacion de Calidad</th>
                                            <th v-if="item.wineryDispatch">Despacho desde Bodega</th>
                                            <th v-if="item.internalDispatchGuide">N° Guía Bodega</th>
                                        </tr>
                                        <tr>
                                            <td v-if="item.estimatedDeliveryDateOenology">
                                                <span class="badge badge-warning" style="font-size: 16px">{{
                                                    item.estimatedDeliveryDateOenologyString }}</span>
                                            </td>
                                            <td v-if="item.deliveryDateOenology">
                                                <span class="badge badge-success" style="font-size: 16px">{{
                                                    item.deliveryDateOenologyString }}</span>
                                            </td>
                                            <td v-if="item.wineryValidatedAt">
                                                <span  class="badge badge-success"
                                                    style="font-size: 16px">{{ item.wineryValidatedAtString }}</span>
                                            </td>
                                            <td v-if="item.qualityValidationDate">
                                                <span class="badge badge-success" style="font-size: 16px">
                                                    {{ item.qualityValidationDateString }}
                                                </span>
                                            </td>
                                            <td v-if="item.wineryDispatch">
                                                <span class="badge badge-primary" style="font-size: 16px">{{
                                                    item.wineryDispatchString }}</span>
                                            </td>
                                            <td v-if="item.internalDispatchGuide">
                                                <span class="badge badge-primary" style="font-size: 16px">{{
                                                    item.internalDispatchGuide }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div v-if="item.rejectionReason" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white"><b>Motivo de rechazo: </b> {{ item.rejectionReason }}</span>
                                </div>
                            </div>
                            <div v-if="item.rejectionWineryDispatchReason" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo:</b>
                                        {{ item.rejectionWineryDispatchReason }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="item.cancelledAt != null" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo Cancelación:</b> {{ item.cancelledReason }}
                                    </span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <a :aria-controls="'collapse' + item.id" :href="'#collapse' + item.id"
                                        aria-expanded="false" class="btn btn-info" data-toggle="collapse" role="button"
                                        style="width: 100%" @click="changeIconCollapse(item.id)">
                                        Componentes
                                        <i :id="'icon' + item.id" class="fas fa-angle-down"></i>
                                    </a>
                                </div>
                                <div v-if="item.dispatchedAt && progressDispatch == 'Si' && tracking
                                    " class="col-md-6">
                                    <a :aria-controls="'collapseTracking' + item.id" :href="'#collapseTracking' + item.id"
                                        aria-expanded="false" class="btn btn-info" data-toggle="collapse" role="button"
                                        style="width: 100%" @click="changeIconTrackingCollapse(item.id)">
                                        Tracking
                                        <i :id="'iconTracking' + item.id" class="fas fa-angle-down"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-12 col-sm-12">
                                    <div :id="'collapse' + item.id" class="collapse multi-collapse mt-2">
                                        <table class="table table-bordered">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th style="width: 20%">Capsula</th>
                                                    <td style="width: 15%">{{ item.capsuleCode }}</td>
                                                    <td>{{ item.capsuleName }}</td>
                                                </tr>
                                                <tr>
                                                    <th>Tapa</th>
                                                    <td>{{ item.cappingCode }}</td>
                                                    <td>{{ item.cappingName }}</td>                                                  
                                                </tr>
                                                <tr>
                                                    <th>Caja</th>
                                                    <td>{{ item.boxCode }}</td>
                                                    <td>{{ item.boxName }}</td>                                           
                                                </tr>
                                                <tr>
                                                    <th>Botella</th>
                                                    <td>{{ item.bottleCode }}</td>
                                                    <td>{{ item.bottleName }}</td>                                               
                                                </tr>
                                                <tr>
                                                    <th>Etiqueta</th>
                                                    <td>{{ item.labelCode }}</td>
                                                    <td>{{ item.labelName }}</td>                                              
                                                </tr>
                                                <tr>
                                                    <th>Contraetiqueta</th>
                                                    <td>{{ item.backLabelCode }}</td>
                                                    <td>{{ item.backLabelName }}</td>                                                 
                                                </tr>
                                            </thead>
                                        </table>
                                         <table class="table table-striped table-bordered">
                                            <tr class="thead-dark">
                                                <th colspan="2">Otro Semielaborado</th>
                                            </tr>
                                            <tr v-if="item.otherSemiElaborateCode">
                                                <td style="width: 22%">
                                                    {{ item.otherSemiElaborateCode }}
                                                </td>
                                                <td style="width: 78%;">
                                                    {{ item.otherSemiElaborateName }}
                                                </td>
                                            </tr>
                                            <tr v-else="">
                                                <td colspan="2" style="width: 73%">
                                                    <span class="badge badge-info">No Establecido</span>
                                                </td>
                                            </tr>                                            
                                        </table>
                                        <table v-if="item.isNewComposition == true"
                                            class="table table-striped table-hover table-bordered">
                                            <thead class="thead-dark">
                                                <tr>
                                                    <th colspan="2">
                                                        Nueva Composición
                                                    </th>
                                                </tr>
                                            </thead>
                                            <thead class="thead-light">
                                                <tr>
                                                    <th>Variedad</th>
                                                    <th>Porcentaje</th>
                                                </tr>
                                                <tr v-for="composition in item.compositionDetails" :key="composition.id">
                                                    <td v-if="item.id ===
                                                        composition.requestCommercialSampleDetailID
                                                        ">
                                                        {{ composition.variety }}
                                                    </td>
                                                    <td v-if="item.id ===
                                                        composition.requestCommercialSampleDetailID
                                                        ">
                                                        {{ composition.percent }}%
                                                    </td>
                                                </tr>
                                            </thead>
                                        </table>
                                        <table class="table table-striped table-hover table-bordered">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th style="width: 25%">Obs. Preparación del Vino</th>
                                                    <td>{{ item.preparationRemarks }}</td>
                                                </tr>
                                                <tr>
                                                    <th>Glosa Sticker</th>
                                                    <td>{{ item.stickerGloss }}</td>
                                                </tr>
                                                <tr>
                                                    <th>Confección Packaging</th>
                                                    <td>{{ item.confectionRemarks }}</td>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                </div>
                                <div v-if="tracking" :id="'collapseTracking' + item.id"
                                    class="col-md-6 collapse multi-collapse mt-2">
                                    <div v-for="t in tracking" :key="t.id">
                                        <table v-if="t.requestCommercialSampleDetailId == item.id"
                                            class="table table-striped table-hover table-bordered">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th style="width: 200px">Courier</th>
                                                    <td>{{ t.tracking.courier }}</td>
                                                </tr>
                                                <tr v-if="t.tracking.internalCourier">
                                                    <th>Interno</th>
                                                    <td><i class="fas fa-check"></i></td>
                                                </tr>
                                                <tr>
                                                    <th>Fecha Despacho</th>
                                                    <td>{{ t.tracking.shippingDateCourierString }}</td>
                                                </tr>
                                                <tr>
                                                    <th v-if="!t.tracking.internalCourier">
                                                        N° Seguimiento
                                                    </th>
                                                    <td v-if="!t.tracking.internalCourier">
                                                        {{ t.tracking.trackingNumber }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th v-if="!t.tracking.internalCourier">N° Guía</th>
                                                    <td v-if="!t.tracking.internalCourier">
                                                        {{ t.tracking.transportDispatchGuide }}
                                                    </td>
                                                </tr>
                                                <tr v-if="!t.tracking.internalCourier">
                                                    <th class="bg-warning" colspan="2">
                                                        <a :href="t.tracking.trackingUrl" class="btn btn-warning"
                                                            style="width: 100%" target="_blank"><b>Ver Seguimiento</b><i
                                                                class="fas fa-truck ml-2"></i></a>
                                                    </th>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-4">
								<div class="col-md-12">
									<table class="table table-stripped table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="3">Observaciones Adicionales</th>
											</tr>
											<tr v-if="item.requestDetailObservations && item.requestDetailObservations.length > 0">
												<th style="width: 18%">Fecha</th>
												<th style="width: 12%">Usuario</th>
												<th style="width: 70%">Observación</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="observation in item.requestDetailObservations" :key="observation.id">
												<td>{{ observation.createdAtString }}</td>
												<td>{{ observation.email }}</td>
												<td>{{ observation.observation }}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
                            <div class="row mt-4">
                                <div class="col-md-12">
                                    <table class="table table-stripped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="5">Documentos Adjuntos</th>
                                            </tr>
                                            <tr v-if="item.documentFiles.length > 0">
                                                <th style="width: 18%">Usuario</th>
                                                <th style="width: 12%">Fecha de Carga</th>
                                                <th style="width: 54%">Nombre del Archivo</th>
                                                <th style="width: 8%">Tipo de Archivo</th>
                                                <th style="width: 8%">Opciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="doc in item.documentFiles" :key="doc.id">
                                                <td>{{ doc.email }}</td>
                                                <td>{{ doc.createdAtString }}</td>
                                                <td>{{ doc.fileName }}</td>
                                                <td style="font-size: 20px">
                                                    <span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
                                                            aria-hidden="true" class="fas fa-file-pdf"></i></span>
                                                    <span v-if="doc.fileExtension == '.jpg' ||
                                                        doc.fileExtension == '.png'
                                                        " class="text-info"><i aria-hidden="true" class="fas fa-image"></i></span>
                                                    <span v-if="doc.fileExtension == '.xls' ||
                                                        doc.fileExtension == '.xlsx'
                                                        " class="text-success"><i aria-hidden="true" class="fas fa-file-excel"></i></span>
                                                    <span v-if="doc.fileExtension == '.doc' ||
                                                        doc.fileExtension == '.docx'
                                                        " class="text-primary"><i class="fas fa-file-word"></i></span>
                                                </td>
                                                <td>
                                                    <button class="btn btn-sm btn-success mr-2"
                                                        @click="downloadFile(doc.id)">
                                                        <i class="fa fa-download"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </card>
        <card v-if="detailFinish.length > 0" title="Producto Terminado">
            <div class="table-responsive">
                <div v-for="item in detailFinish" :key="item.id">
                    <div class="card mb-4 cardShadow">
                        <div class="card-header">
							<div class="row">
								<div class="col-md-12">
									<h5 class="card-title d-inline"><b>SKU: {{ item.sku }}</b></h5>
								</div>
							</div>
						</div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12 text-right">
                                    <div v-if="item.sampleDetailStage > 0" :id="'status-color-' + item.id">
										<h4>
											<b><span :class="'badge ribbon-h-' +item.statusColor" :id="'status-text-' + item.id">
												<i class="fa fa-info-circle mr-4"></i>Estado: {{ item.status }}
											</span></b>
										</h4>
									</div>
                                </div>
                                <div class="col-md-12 table-responsive">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th>Sku</th>
                                                <th>Marca</th>
                                                <th v-if="item.comercialMixCode">Mezcla Comercial</th>
                                                <th>Vino</th>
                                                <th>Botellas</th>
                                                <th>Etapa</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="font-size: 20px !important;">
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.sku }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.brand }}</span>
                                                </td>
                                                <td v-if="item.comercialMixCode">
                                                    <span class="badge badge-info p-2">
                                                        {{ item.comercialMix }} -   {{ item.comercialMixCode }}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.variety }}</span> 
                                                                                                        <span class="badge badge-info p-2 ml-1">{{ item.valley }}</span>
                                                    <span class="badge badge-info p-2 ml-1">{{ item.quality }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-success p-2">{{ item.quantity }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">
                                                        <i class="fa fa-info-circle"></i>
                                                        {{ item.stage }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered">
                                        <tr class="thead-dark text-center">
                                            <th>Sku (Para Despacho)</th>
                                            <th>Muestra Enológica</th>
                                            <th>Con Degustación</th>
                                            <th>Requiere Trasvasije</th>
                                            <th>Vino No Real</th>
                                            <th>No Maquetar</th>
                                            <th>Con Cosecha Histórica/Próxima</th>
                                            <th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                                        </tr>
                                        <tr class="text-center" style="font-size: 20px !important;">
                                            <td>
                                                <span class="badge badge-success p-2">{{ item.finalSku }}</span>
                                            </td>
                                            <td>
                                                <i v-if="item.wineSample" class="fa fa-check text-success"></i>
                                                <i v-if="!item.wineSample" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.withTasting" class="fa fa-check text-success"></i>
                                                <i v-if="!item.withTasting" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.requireTransfer" class="fa fa-check text-success"></i>
                                                <i v-if="!item.requireTransfer" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.notRealWine" class="fa fa-check text-success"></i>
                                                <i v-if="!item.notRealWine" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.notLayout" class="fa fa-check text-success"></i>
                                                <i v-if="!item.notLayout" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.isHistoricalOrUpcoming" class="fa fa-check text-success"></i>
                                                <i v-if="!item.isHistoricalOrUpcoming" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <span class="badge badge-success p-2">{{ item.finalHarvest }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered"
                                        v-if="item.estimatedDeliveryDateOenology
                                            || item.deliveryDateOenology
                                            || item.wineryValidatedAt
                                            || item.qualityValidationDate
                                            || item.wineryDispatch
                                            || item.internalDispatchGuide"    
                                        >
                                        <tr class="thead-dark">
                                            <th v-if="item.estimatedDeliveryDateOenology">Entrega Estimada Enología</th>
                                            <th v-if="item.deliveryDateOenology">Entrega Enología</th>
                                            <th v-if="item.wineryValidatedAt">Validación de Componentes</th>
                                            <th v-if="item.qualityValidationDate">Validación de Calidad</th>
                                            <th v-if="item.wineryDispatch">Despacho desde Bodega</th>
                                            <th v-if="item.internalDispatchGuide">N° Guía Bodega</th>
                                        </tr>
                                        <tr>
                                            <td v-if="item.estimatedDeliveryDateOenology">
                                                <span class="badge badge-warning" style="font-size: 16px">{{
                                                    item.estimatedDeliveryDateOenologyString
                                                }}</span>
                                            </td>
                                            <td v-if="item.deliveryDateOenology">
                                                <span class="badge badge-success" style="font-size: 16px">{{
                                                    item.deliveryDateOenologyString
                                                }}</span>
                                            </td>
                                            <td v-if="item.wineryValidatedAt">
                                                <span class="badge badge-success"
                                                    style="font-size: 16px">{{ item.wineryValidatedAtString }}</span>
                                            </td>
                                            <td v-if="item.qualityValidationDate">
                                                <span class="badge badge-success" style="font-size: 16px">
                                                    {{ item.qualityValidationDateString }}
                                                </span>
                                            </td>
                                            <td v-if="item.wineryDispatch">
                                                <span class="badge badge-success" style="font-size: 16px">{{
                                                    item.wineryDispatchString
                                                }}</span>
                                            </td>
                                            <td v-if="item.internalDispatchGuide">
                                                <span class="badge badge-primary" style="font-size: 16px">{{
                                                    item.internalDispatchGuide
                                                }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div v-if="item.rejectionReason" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white"><b>Motivo de rechazo: </b> {{ item.rejectionReason }}</span>
                                </div>
                            </div>
                            <div v-if="item.rejectionWineryDispatchReason" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo:</b>
                                        {{ item.rejectionWineryDispatchReason }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="item.cancelledAt != null" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo Cancelación:</b> {{ item.cancelledReason }}
                                    </span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <a :aria-controls="'collapse' + item.id" :href="'#collapse' + item.id"
                                        aria-expanded="false" class="btn btn-info" data-toggle="collapse" role="button"
                                        style="width: 100%" @click="changeIconCollapse(item.id)">
                                        Componentes
                                        <i :id="'icon' + item.id" class="fas fa-angle-down"></i>
                                    </a>
                                </div>
                                <div v-if="item.dispatchedAt && progressDispatch == 'Si' && tracking
                                    " class="col-md-6">
                                    <a :aria-controls="'collapseTracking' + item.id" :href="'#collapseTracking' + item.id"
                                        aria-expanded="false" class="btn btn-info" data-toggle="collapse" role="button"
                                        style="width: 100%" @click="changeIconTrackingCollapse(item.id)">
                                        Tracking
                                        <i :id="'iconTracking' + item.id" class="fas fa-angle-down"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-12 col-sm-12">
                                    <div :id="'collapse' + item.id" class="collapse multi-collapse mt-2">
                                        <table class="table table-striped table-hover table-bordered">
                                            <thead class="thead-dark">
                                                <tr v-if="item.saleZoneCode != null">
                                                    <th colspan="3">
                                                        <div class="row">
                                                            <div class="col-md-6">
                                                                Componentes Asociados
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                Zona de venta:
                                                                <span class="ml-2">{{ item.saleZone }}</span>
                                                            </div>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <thead class="thead-light">
                                                <th style="width: 8%">Posición</th>
                                                <th style="width: 15%">Código</th>
                                                <th>Componente</th>
                                            </thead>                                            
                                            <tr v-for="lc in item.components" :key="lc.id">
                                                <td>
                                                    {{ lc.componentPosition }}
                                                </td>
                                                <td style="width: 15%" v-if="lc.requestCommercialSampleDetailId === item.id">
                                                    {{ lc.c_sku }}
                                                </td>
                                                <td colspan="2" v-if="lc.requestCommercialSampleDetailId === item.id">
                                                    {{ lc.d_sku }}
                                                </td>                                               
                                            </tr>
                                        </table>
                                         <table class="table table-striped table-bordered">
                                            <tr class="thead-dark">
                                                <th colspan="2">Semielaborado:</th>
                                            </tr>
                                            <tr>
                                                <td style="width: 15%">{{ item.semiElaborateCode }}</td>
                                                <td>{{ item.semiElaborateName }}</td>                                              
                                            </tr>
                                        </table>
                                        <table class="table table-striped table-bordered">
                                            <tr class="thead-dark">
                                                <th colspan="2">Otro Semielaborado:</th>
                                            </tr>
                                            <tr v-if="item.otherSemiElaborateCode">
                                                <td style="width: 22%">
                                                    {{ item.otherSemiElaborateCode }}
                                                </td>
                                                <td style="width: 73%;">
                                                    {{ item.otherSemiElaborateName }}
                                                </td>
                                            </tr>
                                            <tr v-else="">
                                                <td colspan="2" style="width: 73%">
                                                    <span class="badge badge-info">No Establecido</span>
                                                </td>
                                            </tr>
                                        </table>
                                        <table v-if="item.requestSampleDetailForDispatch" class="table table-striped table-hover table-bordered">
                                            <tr class="thead-dark">
                                                <th colspan="3">
                                                    Componentes Asignados por el Área de Despacho
                                                </th>
                                            </tr>
                                            <tr class="thead-light">
                                                <th colspan="3">
                                                    Zona de venta:
                                                    <span v-if="item.requestSampleDetailForDispatch.saleZoneName" class="ml-2">{{ item.requestSampleDetailForDispatch.saleZoneName }}</span>
                                                    <span v-else="" class="ml-2">{{ item.requestSampleDetailForDispatch.saleZoneCode }}</span>
                                                </th>
                                            </tr>
                                            <template v-if="item.requestSampleDetailForDispatch">
                                                <tr v-for="dc in item.requestSampleDetailForDispatch.requestSampleDetailForDispatchComponents" :key="dc.id">
                                                    <td style="width: 15%"> {{ dc.componentCode }}</td>
                                                    <td>{{ dc.component }}</td>
                                                </tr>
                                            </template>
                                        </table>
                                        <table class="table table-striped table-hover table-bordered">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th style="width: 25%">Obs. Preparación del Vino</th>
                                                    <td>{{ item.preparationRemarks }}</td>
                                                </tr>
                                                <tr>
                                                    <th>Glosa Sticker</th>
                                                    <td>{{ item.stickerGloss }}</td>
                                                </tr>
                                                <tr>
                                                    <th>Confección Packaging</th>
                                                    <td>{{ item.confectionRemarks }}</td>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                </div>
                                <div v-if="tracking" :id="'collapseTracking' + item.id"
                                    class="col-md-6 collapse multi-collapse mt-2">
                                    <div v-for="t in tracking" :key="t.id">
                                        <table v-if="t.requestCommercialSampleDetailId == item.id"
                                            class="table table-striped table-hover table-bordered">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th style="width: 200px">Courier</th>
                                                    <td>{{ t.tracking.courier }}</td>
                                                </tr>
                                                <tr v-if="t.tracking.internalCourier">
                                                    <th>Interno</th>
                                                    <td><i class="fas fa-check"></i></td>
                                                </tr>
                                                <tr>
                                                    <th>Fecha Despacho</th>
                                                    <td>{{ t.tracking.shippingDateCourierString }}</td>
                                                </tr>
                                                <tr v-if="!t.tracking.internalCourier">
                                                    <th>N° Seguimiento</th>
                                                    <td>{{ t.tracking.trackingNumber }}</td>
                                                </tr>
                                                <tr>
                                                    <th v-if="!t.tracking.internalCourier">N° Guía</th>
                                                    <td>{{ t.tracking.transportDispatchGuide }}</td>
                                                </tr>
                                                <tr v-if="!t.tracking.internalCourier">
                                                    <th class="bg-warning" colspan="2">
                                                        <a :href="t.tracking.trackingUrl" class="btn btn-warning"
                                                            style="width: 100%" target="_blank">
                                                            <b>Ver Seguimiento</b>
                                                            <i class="fas fa-truck ml-2"></i>
                                                        </a>
                                                    </th>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-4">
								<div class="col-md-12">
									<table class="table table-stripped table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="3">Observaciones Adicionales</th>
											</tr>
											<tr v-if="item.requestDetailObservations  && item.requestDetailObservations.length > 0">
												<th style="width: 18%">Fecha</th>
												<th style="width: 12%">Usuario</th>
												<th style="width: 70%">Observación</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="observation in item.requestDetailObservations" :key="observation.id">
												<td>{{ observation.createdAtString }}</td>
												<td>{{ observation.email }}</td>
												<td>{{ observation.observation }}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
                            <div class="row mt-4">
                                <div class="col-md-12">
                                    <table class="table table-stripped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="5">Documentos Adjuntos</th>
                                            </tr>
                                            <tr v-if="item.documentFiles.length > 0">
                                                <th style="width: 18%">Usuario</th>
                                                <th style="width: 12%">Fecha de Carga</th>
                                                <th style="width: 54%">Nombre del Archivo</th>
                                                <th style="width: 8%">Tipo de Archivo</th>
                                                <th style="width: 8%">Opciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="doc in item.documentFiles" :key="doc.id">
                                                <td>{{ doc.email }}</td>
                                                <td>{{ doc.createdAtString }}</td>
                                                <td>{{ doc.fileName }}</td>
                                                <td style="font-size: 20px">
                                                    <span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
                                                            aria-hidden="true" class="fas fa-file-pdf"></i></span>
                                                    <span v-if="doc.fileExtension == '.jpg' ||
                                                        doc.fileExtension == '.png'
                                                        " class="text-info"><i aria-hidden="true" class="fas fa-image"></i></span>
                                                    <span v-if="doc.fileExtension == '.xls' ||
                                                        doc.fileExtension == '.xlsx'
                                                        " class="text-success"><i aria-hidden="true" class="fas fa-file-excel"></i></span>
                                                    <span v-if="doc.fileExtension == '.doc' ||
                                                        doc.fileExtension == '.docx'
                                                        " class="text-primary"><i class="fas fa-file-word"></i></span>
                                                </td>
                                                <td>
                                                    <button class="btn btn-sm btn-success mr-2"
                                                        @click="downloadFile(doc.id)">
                                                        <i class="fa fa-download"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </card>
        <card v-if="detailBottle.length > 0" title="Producto Guarda Botella">
            <div class="table-responsive">
                <div v-for="item in detailBottle" :key="item.id">
                    <div class="card mb-4 cardShadow">
                        <div class="card-header">
							<div class="row">
								<div class="col-md-12">
									<h5 class="card-title d-inline"><b>CÓDIGO: {{ item.sku }}</b></h5>
								</div>
							</div>
						</div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12 text-right">
									<div v-if="item.sampleDetailStage > 0" :id="'status-color-' + item.id">
										<h4>
											<b><span :class="'badge ribbon-h-' +item.statusColor" :id="'status-text-' + item.id">
												<i class="fa fa-info-circle mr-4"></i>Estado: {{ item.status }}
											</span></b>
										</h4>
									</div>
								</div>
                                <div class="col-md-12 table-responsive">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th>Código</th>
                                                <th>Marca</th>
                                                <th v-if="item.comercialMixCode">Mezcla Comercial</th>
                                                <th>Vino</th>
                                                <th>Botellas</th>
                                                <th>Etapa</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="font-size: 20px !important;">
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.sku }}</span>
                                                </td>
                                                <td><span class="badge badge-info p-2">{{ item.brand }}</span>
                                                </td>
                                                <td v-if="item.comercialMixCode">
                                                    <span class="badge badge-info p-2">{{ item.comercialMix }} - {{ item.comercialMixCode }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.variety }}</span> 
                                                                                                        <span class="badge badge-info p-2 ml-1">{{ item.valley }}</span>
                                                    <span class="badge badge-info p-2 ml-1">{{ item.quality }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-success p-2">{{ item.quantity }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">
                                                        <i class="fa fa-info-circle"></i>
                                                        {{ item.stage }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered">
                                        <tr class="thead-dark text-center">
                                            <th>Con Degustación</th>
                                            <th>Requiere Trasvasije</th>
                                            <th>Con Cosecha Histórica/Próxima</th>
                                            <th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                                        </tr>
                                        <tr class="text-center" style="font-size: 20px !important;">
                                            <td>
                                                <i v-if="item.withTasting" class="fa fa-check text-success"></i>
                                                <i v-if="!item.withTasting" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.requireTransfer" class="fa fa-check text-success"></i>
                                                <i v-if="!item.requireTransfer" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.isHistoricalOrUpcoming" class="fa fa-check text-success"></i>
                                                <i v-if="!item.isHistoricalOrUpcoming" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <span class="badge badge-success p-2">{{ item.finalHarvest }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered"
                                        v-if="item.wineryValidatedAt
                                            || item.qualityValidationDate
                                            || item.wineryDispatch
                                            || item.internalDispatchGuide"  
                                        >
                                        <tr class="thead-dark">
                                            <th v-if="item.wineryValidatedAt">Validación de Componentes</th>
                                            <th v-if="item.qualityValidationDate">Validación de Calidad</th>
                                            <th v-if="item.wineryDispatch">Despacho desde Bodega</th>
                                            <th v-if="item.internalDispatchGuide">N° Guía Bodega</th>
                                        </tr>
                                        <tr>
                                            <td v-if="item.wineryValidatedAt">
                                                <span class="badge badge-success"
                                                    style="font-size: 16px">{{ item.wineryValidatedAtString }}</span>
                                            </td>
                                            <td v-if="item.qualityValidationDate">
                                                <span class="badge badge-success" style="font-size: 16px">
                                                    {{ item.qualityValidationDateString }}
                                                </span>
                                            </td>
                                            <td v-if="item.wineryDispatch">
                                                <span class="badge badge-success" style="font-size: 16px">{{
                                                    item.wineryDispatchString
                                                }}</span>
                                            </td>
                                            <td v-if="item.internalDispatchGuide">
                                                <span class="badge badge-primary" style="font-size: 16px">{{
                                                    item.internalDispatchGuide
                                                }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div v-if="item.rejectionReason" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white"><b>Motivo de rechazo: </b> {{ item.rejectionReason }}</span>
                                </div>
                            </div>
                            <div v-if="item.rejectionWineryDispatchReason" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo:</b>
                                        {{ item.rejectionWineryDispatchReason }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="item.cancelledAt != null" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo Cancelación:</b> {{ item.cancelledReason }}
                                    </span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <a :aria-controls="'collapse' + item.id" :href="'#collapse' + item.id"
                                        aria-expanded="false" class="btn btn-info" data-toggle="collapse" role="button"
                                        style="width: 100%" @click="changeIconCollapse(item.id)">
                                        Componentes
                                        <i :id="'icon' + item.id" class="fas fa-angle-down"></i>
                                    </a>
                                </div>
                                <div v-if="item.dispatchedAt && progressDispatch == 'Si' && tracking
                                    " class="col-md-6">
                                    <a :aria-controls="'collapseTracking' + item.id" :href="'#collapseTracking' + item.id"
                                        aria-expanded="false" class="btn btn-info" data-toggle="collapse" role="button"
                                        style="width: 100%" @click="changeIconTrackingCollapse(item.id)">
                                        Tracking
                                        <i :id="'iconTracking' + item.id" class="fas fa-angle-down"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-12 col-sm-12">
                                    <div :id="'collapse' + item.id" class="collapse multi-collapse mt-2">
                                        <table class="table table-striped table-hover table-bordered">
                                            <thead class="thead-light">
                                                <tr v-if="item.capsuleName">
                                                    <th style="width: 20%">Capsula</th>
                                                    <td style="width: 15%">{{ item.capsuleCode }}</td>
                                                    <td>{{ item.capsuleName }}</td>
                                                </tr>
                                                <tr v-if="item.cappingName">
                                                    <th>Tapa</th>
                                                    <td>{{ item.cappingCode }}</td>
                                                    <td>{{ item.cappingName }}</td>                                                    
                                                </tr>
                                                <tr v-if="item.boxName">
                                                    <th>Caja</th>
                                                    <td>{{ item.boxCode }}</td>
                                                    <td>{{ item.boxName }}</td>                                                  
                                                </tr>
                                                <tr v-if="item.bottleName">
                                                    <th>Botella</th>
                                                    <td>{{ item.bottleCode }}</td>
                                                    <td>{{ item.bottleName }}</td>
                                                </tr>
                                                <tr v-if="item.labelName">
                                                    <th>Etiqueta</th>
                                                    <td>{{ item.labelCode }}</td>
                                                    <td>{{ item.labelName }}</td>
                                                </tr>
                                                <tr v-if="item.backLabelName">
                                                    <th>Contraetiqueta</th>
                                                    <td>{{ item.backLabelCode }}</td>
                                                    <td>{{ item.backLabelName }}</td>
                                                </tr>
                                            </thead>
                                        </table>
                                        <table v-if="item.requestSampleDetailForDispatch" class="table table-striped table-hover table-bordered">
                                            <tr class="thead-dark">
                                                <th colspan="3">
                                                    Componentes Asignados por el Área de Despacho
                                                </th>
                                            </tr>
                                            <template>
                                                <tr class="thead-light" v-for="dc in item.requestSampleDetailForDispatch.requestSampleDetailForDispatchComponents" :key="dc.id">
                                                    <th style="width: 20%"> {{ dc.family }}</th>
                                                    <td style="width: 15%"> {{ dc.componentCode }} </td>
                                                    <td> {{ dc.component }} </td> 
                                                </tr>
                                            </template>
                                        </table>
                                        <table class="table table-striped table-hover table-bordered">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th style="width: 25%">Obs. Preparación del Vino</th>
                                                    <td>{{ item.preparationRemarks }}</td>
                                                </tr>
                                                <tr>
                                                    <th>Glosa Sticker</th>
                                                    <td>{{ item.stickerGloss }}</td>
                                                </tr>
                                                <tr>
                                                    <th>Confección Packaging</th>
                                                    <td>{{ item.confectionRemarks }}</td>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                </div>
                                <div v-if="tracking" :id="'collapseTracking' + item.id"
                                    class="col-md-6 collapse multi-collapse mt-2">
                                    <div v-for="t in tracking" :key="t.id">
                                        <table v-if="t.requestCommercialSampleDetailId == item.id"
                                            class="table table-striped table-hover table-bordered">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th style="width: 200px">Courier</th>
                                                    <td>{{ t.tracking.courier }}</td>
                                                </tr>
                                                <tr v-if="t.tracking.internalCourier">
                                                    <th>Interno</th>
                                                    <td><i class="fas fa-check"></i>></td>
                                                </tr>
                                                <tr>
                                                    <th>Fecha Despacho</th>
                                                    <td>{{ t.tracking.shippingDateCourierString }}</td>
                                                </tr>
                                                <tr v-if="!t.tracking.internalCourier">
                                                    <th>N° Seguimiento</th>
                                                    <td>{{ t.tracking.trackingNumber }}</td>
                                                </tr>
                                                <tr v-if="!t.tracking.internalCourier">
                                                    <th>N° Guía</th>
                                                    <td>{{ t.tracking.transportDispatchGuide }}</td>
                                                </tr>
                                                <tr v-if="!t.tracking.internalCourier">
                                                    <th class="bg-warning" colspan="2">
                                                        <a :href="t.tracking.trackingUrl" class="btn btn-warning"
                                                            style="width: 100%" target="_blank">
                                                            <b>Ver Seguimiento</b>
                                                            <i class="fas fa-truck ml-2"></i>
                                                        </a>
                                                    </th>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-4">
								<div class="col-md-12">
									<table class="table table-stripped table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="3">Observaciones Adicionales</th>
											</tr>
											<tr v-if="item.requestDetailObservations && item.requestDetailObservations.length > 0">
												<th style="width: 18%">Fecha</th>
												<th style="width: 12%">Usuario</th>
												<th style="width: 70%">Observación</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="observation in item.requestDetailObservations" :key="observation.id">
												<td>{{ observation.createdAtString }}</td>
												<td>{{ observation.email }}</td>
												<td>{{ observation.observation }}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
                            <div class="row mt-4">
                                <div class="col-md-12">
                                    <table class="table table-stripped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="5">Documentos Adjuntos</th>
                                            </tr>
                                            <tr v-if="item.documentFiles.length > 0">
                                                <th style="width: 18%">Usuario</th>
                                                <th style="width: 12%">Fecha de Carga</th>
                                                <th style="width: 54%">Nombre del Archivo</th>
                                                <th style="width: 8%">Tipo de Archivo</th>
                                                <th style="width: 8%">Opciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="doc in item.documentFiles" :key="doc.id">
                                                <td>{{ doc.email }}</td>
                                                <td>{{ doc.createdAtString }}</td>
                                                <td>{{ doc.fileName }}</td>
                                                <td style="font-size: 20px">
                                                    <span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
                                                            aria-hidden="true" class="fas fa-file-pdf"></i></span>
                                                    <span v-if="doc.fileExtension == '.jpg' ||
                                                        doc.fileExtension == '.png'
                                                        " class="text-info"><i aria-hidden="true" class="fas fa-image"></i></span>
                                                    <span v-if="doc.fileExtension == '.xls' ||
                                                        doc.fileExtension == '.xlsx'
                                                        " class="text-success"><i aria-hidden="true" class="fas fa-file-excel"></i></span>
                                                    <span v-if="doc.fileExtension == '.doc' ||
                                                        doc.fileExtension == '.docx'
                                                        " class="text-primary"><i class="fas fa-file-word"></i></span>
                                                </td>
                                                <td>
                                                    <button class="btn btn-sm btn-success mr-2"
                                                        @click="downloadFile(doc.id)">
                                                        <i class="fa fa-download"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </card>
    </card>
</template>
<script>
//import toastr from "toastr";
import { Post, Get } from "../../../helper/axios";
import $ from "jquery";

export default {
    props: [
        "details",
        "request",
        "id",
        "components",
        "progressDispatch",
        "tracking",
        "confirmed",
        "trackingOne",
    ],
    data() {
        return {
            Post,
            Get,
            apiUrl: this.$store.getters.apiUrl,
            detailId: 0,
            listSelectSample: [],
            exist: false,
            updateDispatch: {},
            rejectionReason: "",
            detail: {},
            stock: {}
        };
    },
    created() { },
    methods: {
        confirm() {
            this.$swal({
                title: "¿Desea Confirmar Recepción de Despacho?",
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
            }).then((result) => {
                if (result.value) {
                    this.Post(
                        `${this.apiUrl}v1/requestsample/${this.id}/confirm`,
                        {},
                        () => {
                            //this.$router.push("/");
                            location.reload();
                        }
                    );
                }
            });
        },
        getRequest() {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/requestsamples/", (res) => {
                this.requests = res.data;
                this.$store.commit("setLoading", false);
            });
        },
        changeIconCollapse(item) {
            if ($("#icon" + item).hasClass("fa-angle-down")) {
                $("#icon" + item).toggleClass("fa-angle-up");
            } else if ($("#icon" + item).hasClass("fa-angle-up")) {
                $("#icon" + item).toggleClass("fa-angle-down");
            }
        },
        changeIconTrackingCollapse(item) {
            if ($("#iconTracking" + item).hasClass("fa-angle-down")) {
                $("#iconTracking" + item).toggleClass("fa-angle-up");
            } else if ($("#iconTracking" + item).hasClass("fa-angle-up")) {
                $("#iconTracking" + item).toggleClass("fa-angle-down");
            }
        },
        downloadFile(id) {
            window.open(`${this.apiUrl}v1/documentfile/${id}`);
        },
        showStockModal(type, sku, harvest) {
            this.stock = {}
            this.$store.commit("setLoading", true);
            let data = 'Sku=' + sku + '&Type=' + type
            if (harvest)
                data += '&Harvest=' + harvest
            this.Get(this.apiUrl + "v1/MasterItems/GetStock?" + data, (res) => {
                this.stock = res.data;
                this.$swal({
                    title: "Consulta de Stock",
                    html:   `<table class="table table-sm table-bordered text-left">
                                <tr>
                                    <th style="width: 160px">Tipo</th>
                                    <td>`+this.stock.materialDescription +`</td>
                                </tr>
                                <tr>
                                    <th>Sku</th>
                                    <td>`+this.stock.sku +`</td>
                                </tr>
                                <tr>
                                    <th>Descripción</th>
                                    <td>`+this.stock.skuDescription +`</td>
                                </tr>
                                <tr>
                                    <th>Cosecha (Año)</th>
                                    <td>`+this.stock.harvest +`</td>
                                </tr>
                                <tr>
                                    <th>Stock</th>
                                    <td>`+this.stock.stock +`</td>
                                </tr>
                                <tr>
                                    <th>Actualizado</th>
                                    <td>`+this.stock.updatedStockAtString +`</td>
                                </tr>
                            </table>`,
                    icon: "info",
                    confirmButtonColor: "#3085d6",
                    width: 800
                });
            });
            this.$store.commit("setLoading", false);
        },	        
    },
    computed: {
        detailNew: function () {
            return this.details.filter((x) => x.requestTypeId === 1);
        },
        detailFinish: function () {
            return this.details.filter((x) => x.requestTypeId === 2);
        },
        detailBottle: function () {
            return this.details.filter((x) => x.requestTypeId === 3);
        },
    },
};
</script>
